import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

var DEFAULT_THEME = "light";
var Tooltip = function Tooltip(_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? DEFAULT_THEME : _b,
      children = _a.children;
  var isDarkTheme = theme === "dark";
  var className = classNames(["p-sm", "rounded-base", "inline-block", "text-xs", {
    "bg-light": !isDarkTheme
  }, {
    "bg-darkest": isDarkTheme
  }, {
    "text-body": !isDarkTheme
  }, {
    "text-lightest": isDarkTheme
  }]);
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, children);
};
Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(["light", "dark"])
};

export { Tooltip };
//# sourceMappingURL=index.es.js.map
